import React from 'react';
import { calculateSizeFromStepValues } from '../utils/size-calculator';
import { StepProps } from '../components/Step.component';
import { Size, getSizeLongName } from '../enums/size.enum';
import { Option } from '../models/option';
import { useProductSelection } from '../../hooks/useProductSelection';
import { DivButton } from '../../root/components/DivButton';
import styles from './SizeViewRender.module.scss';
import { Button } from '../../root/components/buttons/Button';

interface Props extends StepProps {
  onChange: (option: Option) => () => void;
}

export const SizeViewRender: React.FC<Props> = (props) => {
  const { setSize } = useProductSelection(props.selectionType, props.selectionKey);
  const size = calculateSizeFromStepValues(props.stepValues, props.productHandle);
  const sizeString = Size[size];

  const selectSize = () => {
    const longSize = getSizeLongName(size);

    if (props.onSizeSelect) {
      props.onSizeSelect(longSize, undefined, true);
      return;
    }

    longSize && setSize(longSize);
    props.onChange(props.data.options[0])();
  };

  return (
    <div className={styles.sizeViewRenderContainer}>
      <div className={styles.hlPerfectFitHeader}>Our recommendation (2?)</div>
      <div className={styles.hlWhiteOptionCard}>
        <div className={styles.hlPerfectFitTitle}>A perfect fit</div>
        <div className={styles.hlPerfectFitSize}>{sizeString}</div>
        <Button onClick={selectSize} text="Select this size" />
      </div>
      <div className={styles.hlSizeViewRenderButtonWrapper}>
        <DivButton onClick={props.onChange(props.data.options[1])} label="Get more accurate sizing">
          Get more accurate sizing »
        </DivButton>
      </div>
    </div>
  );
};
